<div class="bn-care-plan-editor-shell">
  <h2 [id]="headingId()" class="bn-care-plan-editor-shell__heading">
    {{ heading() }}
  </h2>
  <ng-content select="[carePlanEditorTitle]" />
  <div class="bn-care-plan-editor-shell__metadata">
    <ng-content select="[carePlanEditorMetadata]" />
  </div>
  <ng-content />
  <footer class="bn-care-plan-editor-shell__footer">
    <ng-content select="[carePlanEditorFooter]" />
  </footer>
</div>
